import AsyncCruiseDepartureDateYearList from '@/ui/AsyncCruiseDepartureDateYearList'
import {defineType} from 'sanity'

export default defineType({
  name: 'fycYearMonthFilter',
  title: 'FYC Year Month Filter',
  type: 'object',
  fieldsets: [
    {
      name: 'filter',
      title: 'Filter by Departure Years',
    },
  ],

  fields: [
    {
      name: 'year',
      fieldset: 'filter',
      title: 'Filter by Departure Years',
      type: 'string',
      components: {
        input: AsyncCruiseDepartureDateYearList,
      },
      validation: (Rule) => Rule.required(),
    },
    {
      name: 'months',
      fieldset: 'filter',
      title: 'Filter by Departure Months',
      description: 'Leave empty for all months',
      type: 'array',
      of: [{type: 'string'}],
      options: {
        list: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      },
    },
  ],
  preview: {
    select: {
      year: 'year',
      months: 'months',
    },
    prepare: ({year, months}) => {
      return {
        title: months?.map((m: string) => `${year}-${m}`).join(', ') || '',
      }
    },
  },
})
